module.exports = __webpack_public_path__ + "img/Mb_Exhibition_Logo.a6eb1a8e.jpg";